<template>
  <div
    class="main-container"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="this.$t('page.LOADING')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="center-container">
      <div
        class="sub-container"
        v-for="(container, index) in pageInfo.containers"
        :key="index"
      >
        <div
          v-if="pageProperty['页面提示'] && pageProperty['提示位置'] == '上'"
          v-html="pageProperty['页面提示']"
          class="headertips"
          :style="
            container.type == 1
              ? { marginBottom: 0, borderBottom: 'none' }
              : null
          "
        ></div>
        <jt-table
          v-if="showTable(container.type)"
          class="table-comp"
          :columns="container.cols"
          :rows="container.rows"
          :createButton="container.tableButtons.addLine"
          :copyButton="container.tableButtons.copyLines"
          :deleteButton="container.tableButtons.deleteLines"
          @datas="
            (err, rowIdx, colIdx, data, callback) =>
              handleTableDatas(
                err,
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                data,
                callback
              )
          "
          @image-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableImageUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @image-delete="
            (rowIdx, colIdx) =>
              handleTableImageDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @image-upload="
            (file, uploadAction, scaleWH, rowIdx, colIdx) =>
              handleTableImageUpload(
                file,
                uploadAction,
                scaleWH,
                index,
                rowIdx,
                colIdx
              )
          "
          @music-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableMusicUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @music-delete="
            (rowIdx, colIdx) =>
              handleTableMusicDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @video-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableVideoUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @video-delete="
            (rowIdx, colIdx) =>
              handleTableVideoDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @file-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableFileUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @file-delete="
            (rowIdx, colIdx) =>
              handleTableFileDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @create-a-line="
            () => handleCreateALine(pageInfo.pageId, container.containerId)
          "
          @copy-a-line="
            (sourceRow) =>
              handleCopyALine(
                pageInfo.pageId,
                container.containerId,
                sourceRow[0]
              )
          "
          @delete-lines="
            (rows) =>
              handleDeleteLines(pageInfo.pageId, container.containerId, rows)
          "
          @status-button-submit="
            (rowId, tips) =>
              handelButtonSubmit(rowId, tips, container.rows, container.cols)
          "
          @htmlshow="
            (defauleValue, value, rowIdx, colIdx) =>
              handelHtmlShow(
                defauleValue,
                value,
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx
              )
          "
          @openActions="(token) => openActions(token)"
          @openDifficulty="
            (rowIdx, colIdx, data) =>
              openDifficulty(pageInfo.pageId, index, rowIdx, colIdx, data)
          "
          @openRequired="
            (rowIdx, colIdx, data) =>
              openRequired(pageInfo.pageId, index, rowIdx, colIdx, data)
          "
        />

        <jt-form
          v-if="showForm(container.type)"
          class="form-comp"
          :items="container.items"
          :cols="container.columnNum"
          @datas="
            (err, itemIdx, data, callback) =>
              handleFormDatas(
                err,
                pageInfo.pageId,
                index,
                itemIdx,
                data,
                callback
              )
          "
          @image-upload-success="
            (itemIdx, response) =>
              handleFormImageUploadSuccess(
                pageInfo.pageId,
                index,
                itemIdx,
                response
              )
          "
          @image-delete="
            (itemIdx) => handleFormImageDelete(pageInfo.pageId, index, itemIdx)
          "
          @image-upload="
            (file, uploadAction, scaleWH, itemIdx) =>
              handleFormImageUpload(file, uploadAction, scaleWH, index, itemIdx)
          "
          @music-upload-success="
            (itemIdx, response) =>
              handleFormMusicUploadSuccess(
                pageInfo.pageId,
                index,
                itemIdx,
                response
              )
          "
          @music-delete="
            (itemIdx) => handleFormMusicDelete(pageInfo.pageId, index, itemIdx)
          "
          @video-upload-success="
            (itemIdx, response) =>
              handleFormVideoUploadSuccess(
                pageInfo.pageId,
                index,
                itemIdx,
                response
              )
          "
          @video-delete="
            (itemIdx) => handleFormVideoDelete(pageInfo.pageId, index, itemIdx)
          "
          @file-upload-success="
            (itemIdx, response) =>
              handleFormFileUploadSuccess(
                pageInfo.pageId,
                index,
                itemIdx,
                response
              )
          "
          @file-delete="
            (itemIdx) => handleFormFileDelete(pageInfo.pageId, index, itemIdx)
          "
          @createTeam="() => handleCreateTeam()"
        />

        <jt-tablem
          v-if="showTablem(container.type)"
          class="table-comp"
          :columns="container.cols"
          :rows="container.rows"
          :createButton="container.tableButtons.addLine"
          :copyButton="container.tableButtons.copyLines"
          :deleteButton="container.tableButtons.deleteLines"
          @datas="
            (err, rowIdx, colIdx, data, callback) => {
              handleTableDatas(
                err,
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                data,
                callback
              )
            }
          "
          @image-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableImageUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @image-delete="
            (rowIdx, colIdx) =>
              handleTableImageDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @image-upload="
            (file, uploadAction, scaleWH, rowIdx, colIdx) =>
              handleTableImageUpload(
                file,
                uploadAction,
                scaleWH,
                index,
                rowIdx,
                colIdx
              )
          "
          @music-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableMusicUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @music-delete="
            (rowIdx, colIdx) =>
              handleTableMusicDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @video-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableVideoUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @video-delete="
            (rowIdx, colIdx) =>
              handleTableVideoDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @file-upload-success="
            (rowIdx, colIdx, response) =>
              handleTableFileUploadSuccess(
                pageInfo.pageId,
                index,
                rowIdx,
                colIdx,
                response
              )
          "
          @file-delete="
            (rowIdx, colIdx) =>
              handleTableFileDelete(pageInfo.pageId, index, rowIdx, colIdx)
          "
          @create-a-line="
            () => handleCreateALine(pageInfo.pageId, container.containerId)
          "
          @copy-a-line="
            (sourceRow) =>
              handleCopyALine(
                pageInfo.pageId,
                container.containerId,
                sourceRow[0]
              )
          "
          @delete-lines="
            (rows) =>
              handleDeleteLines(pageInfo.pageId, container.containerId, rows)
          "
          @status-button-submit="
            (rowId, tips) =>
              handelButtonSubmit(rowId, tips, container.rows, container.cols)
          "
        />
        <div v-if="showHtml(container.type)" v-html="container.html" />
      </div>
    </div>

    <div class="btn-container">
      <el-button
        class="btn"
        type="primary"
        v-for="(item, index) in pageInfo.buttons"
        @click="handleClick(item)"
        :key="index"
        >{{ item.label }}</el-button
      >
    </div>

    <el-dialog
      :visible.sync="payshow"
      :show-close="false"
      :top="'20vh'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- <div v-html="payContent"></div> -->
      <div class="paydialog" v-if="paystatus === 2">
        <div v-if="paydata.src">
          <p class="title">
            {{
              paydata.body.split('\n')[0]
            }}元，请用微信扫描下方二维码进行支付！(不支持长按识别二维码)
          </p>
          <img :src="paydata.src" alt="" />
          <div class="paydialog-footer">
            <el-button @click="cancelpay">取消支付</el-button>
          </div>
        </div>
        <div v-else>
          <p class="title" style="text-align: center; margin-bottom: 10px">
            {{ paydata.body.split('\n')[0] }}元
          </p>
          <div class="paydialog-footer">
            <el-button @click="cancelpay">取消支付</el-button>
            <el-button @click="confirmpay" type="primary">确认支付</el-button>
          </div>
        </div>
      </div>
      <div class="paysuccessdialog" v-if="paystatus === 3">
        <div class="suctitle">
          <!-- <i class="el-icon-circle-check"></i> -->
          <div v-html="getSuccessTips()"></div>
          <!-- <p>支付完成，您已报名成功，感谢您的使用</p> -->
          <!-- <el-button @click="paysuccess" type="primary">确定</el-button> -->
        </div>
        <!-- <div class="suctitle">
          {{
            tradeNo
              ? '支付完成并报名成功，电子报名表将发送到你的邮箱，感谢您的使用!'
              : '您已报名成功，电子报名表将发到你的邮箱，感谢您的使用！'
          }}
        </div> -->
        <div class="codetab" v-if="res.codes">
          <p>
            视频验证码，请保存好，若要查看，可在本页最下方全部验证码一栏查看
          </p>
          <el-table :data="res.codes" style="width: 100%" border size="mini">
            <el-table-column prop="运动员" label="运动员"> </el-table-column>
            <el-table-column prop="项目" label="项目"> </el-table-column>
            <el-table-column prop="竞赛验证码" label="竞赛验证码">
            </el-table-column>
            <el-table-column prop="测试验证码" label="测试验证码">
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="pdf">
          <a :href="res.url" target="_blank">点击下载电子报名表</a>
        </div> -->
        <div class="successbut">
          <el-button @click="paysuccess" type="primary" size="small">{{
            this.$t('page.SUBMIT_CONFIRM_OK')
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="croppershow"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
      :title="this.$t('page.CAIJIAN')"
    >
      <div class="cropper">
        <VueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :fixedBox="option.fixedBox"
          :fixed="option.fixed"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          :fixedNumber="option.fixedNumber"
        ></VueCropper>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelcropper">{{
          this.$t('page.SUBMIT_CONFIRM_CANCEL')
        }}</el-button>
        <el-button type="primary" @click="submitcropper">{{
          this.$t('page.SUBMIT_CONFIRM_OK')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="createshow"
      :show-close="false"
      :top="'20vh'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-if="successCreate" class="success">
        <div class="successmsg">
          <i class="el-icon-success" style="color: #67c23a"></i>
          <b>{{ teaminfo['队名'] }}</b
          >创建成功，请点击复制邀请链接，粘贴发送给队员
        </div>
        <div class="copybut">
          <el-button
            @click="handelcopy(teaminfo.url)"
            size="small"
            type="danger"
            >复制邀请链接</el-button
          >
          <el-button @click="closesuccess()" size="small">关闭</el-button>
        </div>
      </div>
      <div class="createteam" v-else>
        <div class="tips">
          请注意：仅允许队伍的队长创建队伍;<br />
          队长创建队伍后，复制邀请链接，用微信分享链接给相应的队员；<br />队员注册绑定了本次比赛后，通过微信打开链接，加入队伍!
        </div>
        <label>队伍名称</label>
        <p><el-input size="small" v-model="createform.teamname" /></p>
        <label>参赛项目</label>
        <p><el-input size="small" disabled v-model="createform.event" /></p>
        <label>限制人数</label>
        <p><el-input size="small" disabled v-model="createform.limit" /></p>
        <!-- <label>本人是否队员</label>
        <p>
          <el-radio v-model="createform.inTeam" label="是">是</el-radio
          ><el-radio v-model="createform.inTeam" label="否">否</el-radio>
        </p> -->
        <p style="margin-top: 20px; text-align: center">
          <el-button type="primary" size="small" @click="submitTeam"
            >提交</el-button
          >
          <el-button size="small" @click="cancelcrate" style="margin-left: 20px"
            >取消</el-button
          >
        </p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="htmlEditShow"
      :show-close="false"
      :top="'5vh'"
      :close-on-click-modal="false"
      custom-class="htmldialog"
    >
      <div v-html="htmlEditContent" id="htmlEdit"></div>
      <div class="htmlEditButton">
        <el-button type="success" @click="htmlSave">{{
          this.$t('page.HTML_SAVE')
        }}</el-button
        ><el-button @click="htmlCancel">{{
          this.$t('page.HTML_CLOSE')
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="actionsShow"
      :close-on-click-modal="false"
      center
      custom-class="actionsModal"
      top="4vh"
      :show-close="false"
      :destroy-on-close="true"
    >
      <iframe
        :frameborder="0"
        width="100%"
        style="min-height: 80vh"
        :src="token"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="difficultyShow"
      :close-on-click-modal="false"
      center
      top="10vh"
      custom-class="actionsModal"
      :show-close="false"
      :destroy-on-close="true"
    >
      <div class="difficulty">
        <div class="difficulty-title">
          <p>
            <span
              ><label>{{ this.$t('page.NAME') }}：</label
              >{{ difficultyInfo.athleteName }}</span
            >
            <span
              ><label>{{ this.$t('page.SEX') }}：</label
              >{{ difficultyInfo.sex }}</span
            >
          </p>
          <p>
            <span
              ><label>{{ this.$t('page.GROUP') }}：</label
              >{{ difficultyInfo.groupName }}</span
            >
            <span
              ><label>{{ this.$t('page.EVENT') }}：</label
              >{{ difficultyInfo.eventName2 }}</span
            >
          </p>
        </div>
        <div class="difficulty-input">
          <p class="difficulty-score">
            <span
              ><label>{{ this.$t('page.TOTALVALUE') }}：</label
              >{{ declare.totalScore }}</span
            >
            <span
              ><label>{{ this.$t('page.TECHNIQUES') }}：</label
              >{{ declare.actionScore }}</span
            >
            <span
              ><label>{{ this.$t('page.CONNECTIONS') }}：</label
              >{{ declare.connectionScore }}</span
            >
          </p>
          <el-table
            v-loading="difficultyloading"
            :data="declare.list"
            style="width: 100%; color: #333"
            border
            height="600"
            header-cell-style="background-color: #f3f3f3; color: #505050"
            @cell-click="handleCellClick"
          >
            <el-table-column
              :label="this.$t('page.NO')"
              prop="no"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column :label="this.$t('page.CODE')">
              <template slot-scope="scope">
                <el-select
                  v-model="diffiucltyValue"
                  filterable
                  clearable
                  v-if="showcell(scope.$index)"
                  @change="difficultychange(scope.$index)"
                >
                  <el-option
                    v-for="item in difficulty_list"
                    :key="item.ID"
                    :label="item.codes"
                    :value="item.codes"
                  >
                  </el-option>
                </el-select>
                <span v-else>
                  <el-popover
                    placement="right"
                    trigger="hover"
                    v-if="scope.row.errNumber"
                  >
                    <ul>
                      <li
                        v-for="(item, index) in scope.row.message"
                        :key="index"
                      >
                        {{ index + 1 + '.' + item }}
                      </li>
                    </ul>
                    <a style="color: #f00" slot="reference">{{
                      scope.row.codes
                    }}</a>
                  </el-popover>
                  <b v-else>{{ scope.row.codes }}</b>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('page.TECHNIQUES')">
              <template slot-scope="scope">
                <span>{{ showvalue(scope.row.detail, 0) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="this.$t('page.CONNECTIONS')">
              <template slot-scope="scope">
                <span>{{ showvalue(scope.row.detail, 1) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="this.$t('page.TECHNIQUENAME')"
              prop="explain"
              width="350"
            >
            </el-table-column>
            <el-table-column :label="this.$t('page.OPERATION')">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  circle
                  size="mini"
                  @click="handleAdd(scope.$index)"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-minus"
                  circle
                  size="mini"
                  @click="handleDelete(scope.$index)"
                ></el-button>
                <el-button
                  type="warning"
                  icon="el-icon-top"
                  circle
                  size="mini"
                  v-if="scope.$index != 0"
                  @click="handleUp(scope.$index)"
                ></el-button>
                <el-button
                  type="warning"
                  icon="el-icon-bottom"
                  circle
                  size="mini"
                  v-if="scope.$index != declare.list.length - 1"
                  @click="handleDown(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleDifficultySave(1)"
          type="success"
          style="width: 150px; font-size: 18px"
          :loading="difficultyloading"
          >{{ this.$t('page.HTML_SAVE') }}</el-button
        >
        <el-button
          @click="handleDifficultyclose"
          type="danger"
          style="width: 150px; font-size: 18px"
          >{{ this.$t('page.CLOSE') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="requireShow"
      :close-on-click-modal="false"
      center
      top="10vh"
      custom-class="actionsModal"
      :show-close="false"
      :destroy-on-close="true"
    >
      <div class="difficulty">
        <div class="difficulty-title">
          <p>
            <span
              ><label>{{ this.$t('page.NAME') }}：</label
              >{{ requireInfo.athleteName }}</span
            >
            <span
              ><label>{{ this.$t('page.SEX') }}：</label
              >{{ requireInfo.sex }}</span
            >
          </p>
          <p>
            <span
              ><label>{{ this.$t('page.GROUP') }}：</label
              >{{ requireInfo.groupName }}</span
            >
            <span
              ><label>{{ this.$t('page.EVENT') }}：</label
              >{{ requireInfo.eventName2 }}</span
            >
          </p>
        </div>
        <div class="required-input">
          <p v-for="(item, index) in requireList" :key="index">
            <label>{{ index + 1 }}. </label>
            <el-select
              v-model="requireValue"
              filterable
              clearable
              v-if="showRequirecell(index)"
              style="width: 100%"
              @change="handleRequireChange(index)"
            >
              <el-option
                v-for="(i, j) in actionB_list"
                :key="j"
                :label="i.action"
                :value="i.action"
              >
              </el-option>
            </el-select>
            <b v-else @click="handelRequireClick(index)">{{
              declare_actionB.list[index] && declare_actionB.list[index].action
            }}</b>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleRequireSave"
          type="success"
          style="width: 150px; font-size: 18px"
          :loading="difficultyloading"
          >{{ this.$t('page.HTML_SAVE') }}</el-button
        >
        <el-button
          @click="handleRequireClose"
          type="danger"
          style="width: 150px; font-size: 18px"
          >{{ this.$t('page.CLOSE') }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import jtTable from '../../components/table'
import jtTablem from '../../components/tablem'
import jtForm from '../../components/form'
import PageModel from '../../models/page'
import Formatter from '../../utils/formatter'
import { VueCropper } from 'vue-cropper'
import * as storage from '@/utils/storage'
import * as constants from '@/constants'
import { copy } from '../../utils/tool'
import router from '../../router'
import { Notification } from 'element-ui'
// import "@coze/chat-sdk/webCss";
// import ChatSdk from "@coze/chat-sdk/webJs";

export default {
  name: 'Page',
  components: {
    jtTable,
    jtForm,
    jtTablem,
    VueCropper,
  },
  data() {
    return {
      pageInfo: {}, // 页面信息
      pageProperty: {}, //页面属性
      payshow: false, // 显示支付开关
      createshow: false, //创建队伍开关
      successCreate: false, //成功创建
      payContent: null, // 支付内容
      loading: false,
      croppershow: false,
      timers: null,
      paystatus: 1,
      paydata: {},
      imgPosition: {},
      tradeNo: '',
      res: {},
      option: {
        img: '',
        outputSize: 1,
        full: true,
        outputType: 'jpeg',
        canMove: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        fixed: true,
        centerBox: true,
        fixedBox: false,
        infoTrue: true,
        fixedNumber: [],
        autoCropWidth: '90%',
        autoCropHeight: '90%',
      },
      createform: {
        teamname: '',
        inTeam: 1,
        event: '集体八段锦',
        limit: '5',
      },
      teaminfo: {},
      htmlEditShow: false,
      htmlEditContent: '',
      htmlSaveInfo: {},
      actionsShow: false,
      token: '',
      difficultyShow: false,
      difficulty_list: [],
      declare: { actionScore: 0, connectionScore: 0, list: [], totalScore: 0 },
      difficultyInfo: {},
      rowIdx: -1,
      diffiucltyValue: '',
      difficultyloading: false,
      difficultyId: {},
      requireShow: false,
      actionB_list: [],
      declare_actionB: { list: [] },
      requireInfo: {},
      requireValue: '',
      RequiredId: {},
      requireList: new Array(28),
      requireIndex: -1,
    }
  },

  methods: {
    //打开难度弹窗
    openDifficulty(pageId, index, rowIdx, colIdx, data) {
      this.difficultyId = { pageId, index, rowIdx, colIdx }
      const { declare, difficulty_list, ...other } = data
      this.difficultyShow = true
      this.difficulty_list = difficulty_list
      if (declare) {
        _.map(declare.list, (item, index) => {
          item.no = index + 1
        })
      }
      this.declare = declare
        ? declare
        : {
            actionScore: 0,
            connectionScore: 0,
            list: [
              {
                no: 1,
                codes: '',
                detail: [],
                explain: '',
                score: 0,
              },
            ],
            totalScore: 0,
          }
      this.difficultyInfo = other
    },

    //显示动作分和链接分
    showvalue(detail, type) {
      let value = 0
      _.map(detail, (item) => {
        if (item.type == type) {
          value = parseFloat((value + parseFloat(item.score)).toFixed(2))
        }
      })
      let total = value > 0 ? value : ''
      return total
    },
    //打开难度编辑框
    async handleCellClick(row, column) {
      let { label } = column
      if (
        label == 'Degree of Difficulty Code' ||
        label == '难度编码' ||
        label == '难度编码/Degree of Difficulty Code'
      ) {
        const rowIdx = _.findIndex(
          this.declare.list,
          (item) => item.no === row.no
        )
        this.rowIdx = rowIdx
        this.diffiucltyValue = row.codes
      } else if (this.rowIdx > -1) {
        this.rowIdx = -1
      }
    },

    // 判断是否显示下拉框
    showcell(index) {
      return this.rowIdx == index
    },
    // 难度下拉框改变
    async difficultychange(index) {
      let obj = _.find(
        this.difficulty_list,
        (item) => item.codes == this.diffiucltyValue
      )
      let obj2 = {
        codes: obj.codes,
        detail: obj.detail,
        explain: obj.explain,
        score: obj.score,
        no: index + 1,
      }
      let arr = this.declare.list
      arr[index] = obj2
      this.handelScore(arr)

      // this.rowIdx = -1
    },
    //添加难度
    handleAdd(index) {
      let arr = this.declare.list
      let obj = {
        no: index + 2,
        codes: '',
        detail: [],
        explain: '',
        score: 0,
      }
      arr.splice(index + 1, 0, obj)
      _.map(arr, (item, i) => (item.no = i + 1))
      this.$set(this.declare, 'list', arr)
    },

    //删除难度
    handleDelete(index) {
      let arr = this.declare.list
      if (arr.length > 1) {
        arr.splice(index, 1)
        _.map(arr, (item, i) => (item.no = i + 1))
      } else {
        arr = [
          {
            no: 1,
            codes: '',
            detail: [],
            explain: '',
            score: 0,
          },
        ]
      }
      this.handelScore(arr)
    },

    //难度上移
    handleUp(index) {
      let arr = this.declare.list

      if (index > 0) {
        let obj = _.cloneDeep(arr[index])
        arr[index] = arr[index - 1]
        arr[index - 1] = obj
        _.map(arr, (item, i) => (item.no = i + 1))
        this.handelScore(arr)
      }
    },
    //难度下移
    handleDown(index) {
      let arr = this.declare.list
      if (index < arr.length - 1) {
        let obj = _.cloneDeep(arr[index])
        arr[index] = arr[index + 1]
        arr[index + 1] = obj
        _.map(arr, (item, i) => (item.no = i + 1))
        this.handelScore(arr)
      }
    },
    //处理难度分数
    async handelScore(arr) {
      let ascore = 0
      let cscore = 0
      let newarr = arr

      _.map(newarr, (item) => {
        if (item.codes) {
          let obj = _.find(
            this.difficulty_list,
            (items) => items.codes == item.codes
          )

          item.detail = _.cloneDeep(obj.detail)
          let tscore = 0
          _.map(item.detail, (i) => {
            if (i.type == 0) {
              let oldscore = _.cloneDeep(ascore)
              ascore = parseFloat((ascore + parseFloat(i.score)).toFixed(2))
              // console.log(ascore)
              if (ascore > 1.4) {
                i.score = (1.4 - oldscore).toFixed(2)
                ascore = 1.4
              }
            } else {
              let oldscore = _.cloneDeep(cscore)
              cscore = parseFloat((cscore + parseFloat(i.score)).toFixed(2))
              if (cscore > 0.6) {
                i.score = (0.6 - oldscore).toFixed(2)
                cscore = 0.6
              }
            }
            tscore = parseFloat((tscore + parseFloat(i.score)).toFixed(2))
            if (i.dtypeName || i.difsortName) {
              delete i.difsortName
              delete i.dtypeName
            }
          })
          item.score = tscore.toFixed(2)
        }
      })
      this.$set(this.declare, 'totalScore', (ascore + cscore).toFixed(2))
      this.$set(this.declare, 'actionScore', ascore.toFixed(2))
      this.$set(this.declare, 'connectionScore', cscore.toFixed(2))
      this.declare.list = [...newarr]
      this.handleDifficultySave()
    },

    // 点击难度关闭
    handleDifficultyclose() {
      // this.$confirm(this.$t('page.DIFFICULTY_CLOSE_TIPS')).then(async () => {

      // })
      const back = (data) => {
        if (data) {
          this.difficultyInfo = {}
          this.difficultyShow = false
          this.difficulty_list = []
          this.declare = {
            actionScore: 0,
            connectionScore: 0,
            list: [],
            totalScore: 0,
          }
          this._initPage()
        }
      }
      this.handleDifficultySave(1, back)
    },
    //保存难度
    async handleDifficultySave(tag, callback) {
      this.difficultyloading = true
      if (tag) {
        this.rowIdx = -1
      }
      let config = storage.getItem(constants.GLOBAL_CONFIG)
      let { gameId, teamId } = config
      let other = this.difficultyInfo
      let declare = _.cloneDeep(this.declare)
      let declare1 = _.cloneDeep(this.declare)
      _.map(declare.list, (item) => {
        delete item.explain
        delete item.no
        delete item.errNumber
        delete item.message
      })
      _.map(declare1.list, (item) => {
        delete item.errNumber
        delete item.message
      })
      let list = _.filter(declare.list, (item) => item.codes != '')
      declare.list = list
      let obj = {
        gameId: parseInt(gameId),
        teamId: parseInt(teamId),
        ...other,
        declare: declare.list.length > 0 ? declare : null,
      }
      let data = await PageModel.uploadDifficulty(obj)
      if (data.errNo == 0) {
        if (data.payload.difficulty_errNo == 0) {
          if (tag) {
            Notification({
              title: this.$t('page.HTML_SAVE_SUCCESS'),
              type: 'success',
            })
          }
          function back(res) {}
          let languageConfig = storage.getItem(constants.LANGUAGE)
          let arr = []
          _.map(declare.list, (item) => {
            _.map(item.detail, (i) => {
              arr.push(i)
            })
          })

          let saveValue = {
            athleteName: obj.athleteName,
            event: languageConfig == 'zh' ? obj.eventName : obj.eventName2,
            difficultCount: declare.list.length,
            totalValue: declare.totalScore,
            actionScore: declare.actionScore,
            connectionScore: declare.connectionScore,
            declare: arr,
          }

          let value =
            parseFloat(declare.totalScore) > 0 ? JSON.stringify(saveValue) : ''
          let { pageId, index, rowIdx, colIdx } = this.difficultyId
          this.handleTableDatas(
            null,
            pageId,
            index,
            rowIdx,
            colIdx,
            value,
            back
          )
          this.$set(this.declare, 'list', declare1.list)
          this.difficultyloading = false
          callback(1)
        } else {
          // Notification({
          //   title: this.$t('page.SUBMIT_FAIL'),
          //   message: data.payload.difficulty_msg,
          //   type: 'error',
          // })
          let report_list = data.payload.report_list || []
          _.map(declare1.list, (item, index) => {
            if (item.codes == '') {
              report_list.splice(index, 0, { codes: '', errNumber: 0 })
            }
          })
          let msg = (
            <div>
              <h5>{data.payload.difficulty_msg}</h5>
              <ul>
                {_.map(
                  report_list,
                  (item, index) =>
                    item.errNumber > 0 && (
                      <li key={index} style="margin-top:10px;">
                        {index + 1}.{item.message.join(',')}
                      </li>
                    )
                )}
              </ul>
            </div>
          )
          this.$message({
            showClose: true,
            message: msg,
            type: 'error',
            duration: 5000,
          })
          _.map(declare1.list, (item, index) => {
            if (report_list[index].errNumber > 0) {
              item.errNumber = report_list[index].errNumber
              item.message = report_list[index].message
            }
          })
          this.$set(this.declare, 'list', declare1.list)
          this.difficultyloading = false
        }
      } else {
        Notification({
          title: this.$t('page.SUBMIT_FAIL'),
          message: data.errMsg,
          type: 'error',
        })
      }
      this.difficultyloading = false
    },

    //打开必选动作弹窗
    openRequired(pageId, index, rowIdx, colIdx, data) {
      this.RequiredId = { pageId, index, rowIdx, colIdx }
      const { declare_actionB, actionB_list, ...other } = data
      this.requireShow = true
      this.actionB_list = actionB_list
      this.declare_actionB = declare_actionB ? declare_actionB : { list: [] }
      this.requireInfo = other
    },

    // 点击必选关闭
    handleRequireClose() {
      // this.$confirm(this.$t('page.DIFFICULTY_CLOSE_TIPS')).then(async () => {
      //   this.requireShow = false
      //   this.actionB_list = []
      //   this.declare_actionB = { list: [] }
      //   this.requireInfo = {}
      //   this.difficultyloading = false
      //   await this._initPage()
      // })

      const back = (data) => {
        if (data) {
          this.requireShow = false
          this.actionB_list = []
          this.declare_actionB = { list: [] }
          this.requireInfo = {}
          this._initPage()
        }
      }
      this.handleRequireSave(back)
    },

    //保存必选动作
    async handleRequireSave(callback) {
      this.difficultyloading = true
      let config = storage.getItem(constants.GLOBAL_CONFIG)
      let { gameId, teamId } = config
      let other = this.requireInfo
      let declare_actionB = this.declare_actionB
      declare_actionB.list = _.filter(declare_actionB.list, (item) => !!item)

      let obj = {
        gameId: parseInt(gameId),
        teamId: parseInt(teamId),
        ...other,
        declare_actionB:
          declare_actionB.list.length > 0 ? declare_actionB : null,
      }
      let data = await PageModel.uploadRequired(obj)
      if (data.errNo == 0) {
        Notification({
          title: this.$t('page.HTML_SAVE_SUCCESS'),
          type: 'success',
        })
        function back(res) {}
        let languageConfig = storage.getItem(constants.LANGUAGE)
        let saveValue = {
          athleteName: obj.athleteName,
          event: languageConfig == 'zh' ? obj.eventName : obj.eventName2,
          count: declare_actionB.list.length,
          declare: declare_actionB.list,
        }

        let value =
          declare_actionB.list.length > 0 ? JSON.stringify(saveValue) : ''
        let { pageId, index, rowIdx, colIdx } = this.RequiredId
        this.handleTableDatas(null, pageId, index, rowIdx, colIdx, value, back)
        this.difficultyloading = false
        callback(1)
      } else {
        Notification({
          title: this.$t('page.SUBMIT_FAIL'),
          message: data.errMsg,
          type: 'error',
        })
        this.difficultyloading = false
      }
    },

    //点击弹出选择框
    handelRequireClick(index) {
      this.requireIndex = index
      let action = this.declare_actionB.list[index]
        ? this.declare_actionB.list[index].action
        : ''
      this.requireValue = action
    },

    showRequirecell(index) {
      return index == this.requireIndex
    },
    //必选动作改变
    handleRequireChange(index) {
      let value = this.requireValue
      let obj = _.find(this.actionB_list, (item) => item.action == value)
      obj = obj ? obj : null
      this.$set(this.declare_actionB.list, index, obj)
      this.requireIndex = -1
      this.requireValue = ''
    },

    //获取支付成功后的信息
    getSuccessTips() {
      const { submitTips } = storage.getItem(constants.GLOBAL_CONFIG)
      let a = submitTips
        ? submitTips
        : this.tradeNo
        ? '支付完成，您已报名成功，感谢您的使用'
        : this.$t('page.SUBMIT_SUCCESS')
      return a
    },
    async handleClick(btnObj) {
      if (btnObj.type === 1) {
        setTimeout(() => {
          this.$router.push(btnObj.pageUrl)
        }, 500)
      } else if (btnObj.type === 2) {
        setTimeout(() => {
          let item = this.pageInfo.containers[0].items
          if (item) {
            let str = false
            for (let index = 0; index < item.length; index++) {
              let element = item[index]
              if (element.required === true && element.value === '') {
                str = true
                break
              }
            }
            if (str) {
              const msg = this.$t('page.TIPS_FOR_NEXT')
              const title = this.$t('global.TIPS')
              this.$confirm(msg, title, {
                confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
                cancelButtonText: this.$t('page.SUBMIT_CONFIRM_CANCEL'),
              })
                .then(() => {
                  this.$router.push(btnObj.pageUrl)
                })
                .catch(() => {})
            } else {
              this.$router.push(btnObj.pageUrl)
            }
          } else {
            this.$router.push(btnObj.pageUrl)
          }
        }, 500)
        // type 1: 上一页, type 2: 下一页
      } else if (btnObj.type === 3) {
        // type 3: 提交

        const { weChatPay, submitTips, gameData } = storage.getItem(
          constants.GLOBAL_CONFIG
        )

        const wxinfo =
          storage.getItem(constants.WX_INFO) || storage.getItem('oid')
        const ua = window.navigator.userAgent.toLowerCase()
        const isphone = /android|webos|iphone|ipod|blackberry|ipad/i.test(ua)

        const content = gameData.submitConfirm
          ? gameData.submitConfirm
          : weChatPay
          ? this.$t('page.SUBMIT_CONFIRM_WECHATPAY_CONTENT')
          : this.$t('page.SUBMIT_CONFIRM_CONTENT')
        const title = this.$t('page.SUBMIT_CONFIRM_TITLE')
        const ok = this.$t('page.SUBMIT_CONFIRM_OK')
        const cancel = this.$t('page.SUBMIT_CONFIRM_CANCEL')
        const success = submitTips ? submitTips : this.$t('page.SUBMIT_SUCCESS')
        const fail = this.$t('page.SUBMIT_FAIL')
        // const calcelSubmit = this.$t('page.SUBMIT_CONFIRM_CANCEL_CONTENT', {
        //   label: btnObj.label,
        //   label2: '提交',
        // })
        const issubmit = this.$t('page.IS_SUBMITTED')
        let con = content
        // if (btnObj.label != '提交' && btnObj.label != '支付并提交'  && btnObj.label != 'Submit') {
        //   con = calcelSubmit
        // } else {
        //   con = content
        // }
        let res
        if (!isphone && weChatPay && wxinfo) {
          this.$alert(
            '信息会自动保存，请使用非微信浏览器进入网站支付',
            '提示',
            {
              type: 'warning',
              confirmButtonText: ok,
            }
          )
        } else {
          await this.$msgbox({
            title: title,
            message: con,
            showCancelButton: true,
            confirmButtonText: ok,
            cancelButtonText: cancel,
            dangerouslyUseHTMLString: true,
            type: 'warning',
            beforeClose: async (action, instance, done) => {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true
                instance.confirmButtonText = issubmit
                res = await PageModel.submit()
                if (res) {
                  instance.confirmButtonLoading = false
                  done()
                }
              } else {
                done()
              }
            },
          }).then(async () => {
            this.res = res
            if (res.success || res.tradeNo) {
              if (res.tradeNo) {
                this.tradeNo = res.tradeNo
                localStorage.setItem('tradeNo', res.tradeNo)
                if (res.wxPay && res.wxPay === 'JSAPI') {
                  let { returnData, body } = res
                  this.payshow = true
                  this.paystatus = 2
                  this.paydata = { body }
                  this.paycofig = returnData
                } else {
                  let { content, mimeType, tradeNo, body } = res
                  let src = 'data:' + mimeType + ';base64,' + content
                  this.payshow = true
                  this.paystatus = 2
                  this.paydata = { body, src }
                  this.checkpaystatue(tradeNo)
                }
              } else {
                this.payshow = true
                this.paystatus = 3
                // this.$alert(success, '', {
                //   type: 'success',
                //   confirmButtonText: ok,
                //   dangerouslyUseHTMLString: true,
                //   callback: () => {
                //     window.history.go(0)
                //   },
                // })
              }
            } else {
              let alertTitle = res.submitted ? '操作成功' : fail
              let errorMessage = ''
              _.forEach(res.messages, (message, index) => {
                errorMessage += `<div>${index + 1}. ${message}</div>`
              })

              try {
                this.$alert(errorMessage, alertTitle, {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: ok,
                }).then(() => {
                  if (btnObj.label == '取消提交'|| btnObj.label == 'Cancel Submission' || btnObj.label == '取消提交/Cancel Submission') {
                    const info = storage.getItem(constants.WX_INFO)
                    const router = this.$router
                    if (info) {
                      storage.setItem(constants.GLOBAL_CONFIG, null)
                      router.push(`/wxlogin.html`)
                    } else {
                      let logo = storage.getItem(constants.LOGO)
                      storage.clear()
                      if (logo !== -1) {
                        storage.setItem(constants.LOGO, logo)
                      }
                      window.location.href = '/login.html'
                    }
                  }
                })
              } catch (err) {}
            }
          })
        }
      } else if (btnObj.type === 4) {
        // type 4: 打印页
        const res = await PageModel.getPrintContent()
        this.printDoc(res.print)
      } else if (btnObj.type === 5) {
        // type 5: pdf下载页
        window.location.href = btnObj.url
      }
    },

    async checkpaystatue(params) {
      let tradeNo = params
      let data = await PageModel.getpaystatue(tradeNo)
      if (data.errNo === 0) {
        this.paystatus = 3
        this.paydata = {}
        localStorage.removeItem('tradeNo')
      } else if (data.errNo === 1) {
        this.checkpaystatue(tradeNo)
      }
    },

    confirmpay() {
      const ok = this.$t('page.SUBMIT_CONFIRM_OK')
      let returnData = this.paycofig
      let wx = require('weixin-js-sdk')
      var that = this
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: returnData.appId, // 必填，公众号的唯一标识
        timestamp: returnData.timeStamp, // 必填，生成签名的时间戳
        nonceStr: returnData.nonceStr, // 必填，生成签名的随机串
        signature: returnData.sign, // 必填，签名
        jsApiList: ['chooseWXPay'], // 必填，需要使用的JS接口列表
      })
      wx.ready((res) => {
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: (res) => {},
          fail: (err) => {
            that.$alert(err, '', {
              type: 'error',
              confirmButtonText: ok,
            })
          },
        })
      })
      wx.chooseWXPay({
        timestamp: returnData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: returnData.nonceStr, // 支付签名随机串，不长于 32 位
        package: returnData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: returnData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: returnData.sign, // 支付签名
        // 支付成功后的回调函数
        success: function (res) {
          that.paystatus = 3
          localStorage.removeItem('tradeNo')
        },
        // 支付取消回调函数
        cancel: function (res) {},
        // 支付失败回调函数
        fail: function (res) {
          that.$alert('支付失败,请重新支付或联系工作人员', '', {
            type: 'error',
            confirmButtonText: ok,
            callback: () => {
              window.history.go(0)
            },
          })
        },
      })
    },

    cancelpay() {
      const title = this.$t('page.SUBMIT_CONFIRM_TITLE')
      const con = this.$t('page.CANCELPAY_CONFIRM_CONTENT')
      const ok = this.$t('page.SUBMIT_CONFIRM_OK')
      const cancel = this.$t('page.SUBMIT_CONFIRM_CANCEL')
      this.$msgbox({
        title: title,
        message: con,
        showCancelButton: true,
        confirmButtonText: ok,
        cancelButtonText: cancel,
        type: 'warning',
      }).then(async () => {
        let data = await PageModel.cancelpay(this.tradeNo)
        if (data.errNo === 0) {
          localStorage.removeItem('tradeNo')
          this.payshow = false
          if (this.timers) {
            this.paystatus = 1
            clearInterval(this.timers)
          }
          window.history.go(0)
        }
      })
    },

    paysuccess() {
      window.history.go(0)
    },
    //提交创建队伍信息
    async submitTeam() {
      let { teamname, event, inTeam } = this.createform
      if (_.trim(teamname)) {
        let data = await PageModel.createTeam(teamname, event, inTeam)
        if (data.errNo === 0) {
          this.successCreate = true
          this.teaminfo = data.payload
        }
      } else {
        this.$message.error('队伍名称不能为空！')
      }
    },

    //打开创建队伍
    handleCreateTeam() {
      this.createshow = true
    },
    //关闭创建队伍
    cancelcrate() {
      this.createshow = false
    },

    handelcopy(url) {
      let a = copy(url)
      if (a) {
        this.$message.success('复制成功！')
      }
    },
    closesuccess() {
      this.createshow = false
      this.$router.go(0)
    },
    // 调用浏览器打印功能打印页面内容
    printDoc(printContent) {
      let iframe = document.createElement('IFRAME')
      let doc = null
      iframe.setAttribute(
        'style',
        'position:absolute;width:0px;height:0px;left:-500px;top:-500px;'
      )
      document.body.appendChild(iframe)
      doc = iframe.contentWindow.document
      doc.write(printContent)
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
      document.body.removeChild(iframe)
    },
    /** 显示表格 */
    showTable(type) {
      return type === 1 && window.innerWidth > 600
    },
    /** 显示手机表格 */
    showTablem(type) {
      return type === 1 && window.innerWidth <= 600
    },
    /** 显示表单 */
    showForm(type) {
      return type === 2
    },
    /** 显示HTML */
    showHtml(type) {
      return type === 3
    },
    /** 保存单元格编辑的数据 */
    async handleTableDatas(
      err,
      pageId,
      containerIdx,
      rowIdx,
      colIdx,
      data,
      callback
    ) {
      let res = true
      if (err) {
        res = false
        // const title = this.$t('global.ERROR')

        // await this.$alert(err.message, title, {
        //   type: 'error',
        //   showClose: false
        // })

        this.$message({
          type: 'error',
          message: err.message,
        })

        callback(res)
        return
      }
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      let ret = null

      try {
        ret = await PageModel.saveData({
          pageId,
          containerId,
          rowId,
          colId,
          data,
        })
      } catch (error) {
        res = false
        callback(res)
        throw error
      }

      row[colId].value = data
      // 处理服务器返回结果，修改model的当前行其他列的值
      let otherColumnDataChange = false
      if (ret) {
        _.forEach(ret, (retItem) => {
          const { colId, change } = retItem
          _.forEach(change, (item) => {
            row[colId][item.property] = item.value
          })
        })

        otherColumnDataChange = true
      }

      this.$set(container.rows, rowIdx, row)

      callback(res, otherColumnDataChange)
    },

    /** 保存表单项的数据 */
    async handleFormDatas(err, pageId, containerIdx, index, data, callback) {
      let res = true
      if (err) {
        res = false
        // const title = this.$t('global.ERROR')

        // await this.$alert(err.message, title, {
        //   type: 'error',
        //   showClose: false
        // })

        this.$message({
          type: 'error',
          message: err.message,
        })

        callback(res)
        return
      }

      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const rowId = -1
      const item = container.items[index]
      const colId = item.id

      let ret = null
      try {
        ret = await PageModel.saveData({
          pageId,
          containerId,
          rowId,
          colId,
          data,
        })
      } catch (error) {
        res = false
        callback(res)
        throw error
      }

      item.value = data
      this.$set(container.items, index, item)
      // 处理服务器返回结果，修改model的当前行其他列的值
      if (ret) {
        _.forEach(ret, (retItem) => {
          const { id, change } = retItem
          const idx = _.findIndex(container.items, (i) => i.id === `${id}`)

          if (idx !== -1) {
            const newItem = container.items[idx]
            _.forEach(change, (i) => {
              newItem[i.property] = i.value
            })
            this.$set(container.items, idx, newItem)
          }
        })
      }
      callback(res)
    },
    /** 上传图片成功的回调函数 */
    handleTableImageUploadSuccess(
      pageId,
      containerIdx,
      rowIdx,
      colIdx,
      response
    ) {
      const container = this.pageInfo.containers[containerIdx]
      const row = container.rows[rowIdx]
      const col = container.cols[colIdx]
      const colId = col.colId

      const imageId = response.imageId
      const url = response.url
      // row[colId].value = `/web/api/v2/page/image/p/${imageId}`
      row[colId].value = url
      this.$set(container.rows, rowIdx, row)
    },
    /** 删除图片 */
    async handleTableImageDelete(pageId, containerIdx, rowIdx, colIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      const imageSrc = row[colId].value
      const array = _.split(imageSrc, '/')
      const imageId = array[array.length - 1]

      await PageModel.deleteImage({
        pageId,
        containerId,
        rowId,
        colId,
        imageId,
      })

      row[colId].value = ''
      this.$set(container.rows, rowIdx, row)
    },
    /** table上传图片 */
    handleTableImageUpload(
      file,
      uploadAction,
      scaleWH,
      containerIdx,
      rowIdx,
      colIdx
    ) {
      this.imgPosition = { uploadAction, containerIdx, rowIdx, colIdx }
      let arr = scaleWH.split('|')
      arr[0] = Number(arr[0])
      arr[1] = Number(arr[1])
      let that = this
      this.readBlobAsDataURL(file, (dataurl) => {
        that.option.img = dataurl
        that.option.fixedNumber = arr
        that.croppershow = true
      })
    },
    /** File对象转换为dataURL */
    readBlobAsDataURL(blob, callback) {
      var a = new FileReader()
      a.onload = (e) => {
        callback(e.target.result)
      }
      a.readAsDataURL(blob)
    },
    /** 取消裁剪 */
    cancelcropper() {
      this.option.img = ''
      this.croppershow = false
    },
    /** 确认裁剪并上传 */
    submitcropper() {
      // 获取截图的blob数据
      let { uploadAction, containerIdx, rowIdx, colIdx, itemIdx } =
        this.imgPosition
      this.$refs.cropper.getCropBlob(async (data) => {
        var formData = new FormData()
        formData.append('file', data)
        const res = await PageModel.uploadImg(uploadAction, formData)
        const container = this.pageInfo.containers[containerIdx]
        if (itemIdx) {
          const item = container.items[itemIdx]
          // item.src = `/web/api/v2/page/image/p/${res.imageId}`
          // item.value = `/web/api/v2/page/image/p/${res.imageId}`
          item.src = res.url
          item.value = res.url
          this.$set(container.items, itemIdx, item)
        } else {
          const row = container.rows[rowIdx]
          const col = container.cols[colIdx]
          const colId = col.colId
          // row[colId].value = `/web/api/v2/page/image/p/${res.imageId}`
          row[colId].value = res.url
          this.$set(container.rows, rowIdx, row)
        }
        this.croppershow = false
        this.option.img = ''
      })
    },
    /** 上传音乐成功的回调函数 */
    handleTableMusicUploadSuccess(
      pageId,
      containerIdx,
      rowIdx,
      colIdx,
      response
    ) {
      const container = this.pageInfo.containers[containerIdx]
      const row = container.rows[rowIdx]
      const col = container.cols[colIdx]
      const colId = col.colId

      const musicId = response.musicId
      const url = response.url
      const musicName = response.musicName
      // row[colId].value = `/api/v2/page/music/${musicId}`
      row[colId].value = url
      row[colId].musicName = musicName
      this.$set(container.rows, rowIdx, row)
    },
    /** 删除音乐 */
    async handleTableMusicDelete(pageId, containerIdx, rowIdx, colIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      const musicSrc = row[colId].value
      const array = _.split(musicSrc, '/')
      const musicId = array[array.length - 1]

      await PageModel.deleteMusic({
        pageId,
        containerId,
        rowId,
        colId,
        musicId,
      })

      row[colId].value = ''
      row[colId].musicName = ''
      this.$set(container.rows, rowIdx, row)
    },
    /** 上传视频成功的回调函数 */
    handleTableVideoUploadSuccess(
      pageId,
      containerIdx,
      rowIdx,
      colIdx,
      response
    ) {
      const container = this.pageInfo.containers[containerIdx]
      const row = container.rows[rowIdx]
      const col = container.cols[colIdx]
      const colId = col.colId

      const videoId = response.musicId
      const url = response.url
      const videoName = response.videoName
      // row[colId].value = `/api/v2/page/music/${videoId}`
      row[colId].value = url
      row[colId].videoName = videoName
      this.$set(container.rows, rowIdx, row)
    },
    /** 删除视频 */
    async handleTableVideoDelete(pageId, containerIdx, rowIdx, colIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      const videoSrc = row[colId].value
      const array = _.split(videoSrc, '/')
      const videoId = array[array.length - 1]

      await PageModel.deleteVideo({
        pageId,
        containerId,
        rowId,
        colId,
        videoId,
      })

      row[colId].value = ''
      row[colId].videoName = ''
      this.$set(container.rows, rowIdx, row)
    },
    /** 上传文件成功的回调函数 */
    handleTableFileUploadSuccess(
      pageId,
      containerIdx,
      rowIdx,
      colIdx,
      response
    ) {
      const container = this.pageInfo.containers[containerIdx]
      const row = container.rows[rowIdx]
      const col = container.cols[colIdx]
      const colId = col.colId

      const fileId = response.fileId
      const url = response.url
      const fileName = response.fileName
      // row[colId].value = `/api/v2/page/file/${fileId}`
      row[colId].value = url
      row[colId].fileName = fileName
      this.$set(container.rows, rowIdx, row)
    },
    /** 删除文件 */
    async handleTableFileDelete(pageId, containerIdx, rowIdx, colIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      const fileSrc = row[colId].value
      const array = _.split(fileSrc, '/')
      const fileId = array[array.length - 1]

      await PageModel.deleteFile({
        pageId,
        containerId,
        rowId,
        colId,
        fileId,
      })

      row[colId].value = ''
      row[colId].fileName = ''
      this.$set(container.rows, rowIdx, row)
    },
    /** 上传图片成功的回调函数 */
    handleFormImageUploadSuccess(pageId, containerIdx, itemIdx, response) {
      const container = this.pageInfo.containers[containerIdx]
      const item = container.items[itemIdx]
      const imageId = response.imageId
      const url = response.url
      // item.src = `/web/api/v2/page/image/p/${imageId}`
      // item.value = `/web/api/v2/page/image/p/${imageId}`
      item.src = url
      item.value = url
      this.$set(container.items, itemIdx, item)
    },
    /** form上传图片 */
    handleFormImageUpload(file, uploadAction, scaleWH, containerIdx, itemIdx) {
      this.imgPosition = { uploadAction, containerIdx, itemIdx }
      let arr = scaleWH.split('|')
      arr[0] = Number(arr[0])
      arr[1] = Number(arr[1])
      let that = this
      this.readBlobAsDataURL(file, (dataurl) => {
        that.option.img = dataurl
        that.option.fixedNumber = arr
        that.croppershow = true
      })
    },

    /** 删除图片 */
    async handleFormImageDelete(pageId, containerIdx, itemIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const rowId = -1
      const item = container.items[itemIdx]
      const colId = item.id

      const imageSrc = item.src
      const array = _.split(imageSrc, '/')
      const imageId = array[array.length - 1]

      await PageModel.deleteImage({
        pageId,
        containerId,
        rowId,
        colId,
        imageId,
      })

      item.src = ''
      item.value = ''
      this.$set(container.items, itemIdx, item)
    },
    /** 上传音乐成功的回调函数 */
    handleFormMusicUploadSuccess(pageId, containerIdx, itemIdx, response) {
      const container = this.pageInfo.containers[containerIdx]
      const item = container.items[itemIdx]
      const musicId = response.musicId
      const url = response.url
      const musicName = response.musicName
      // item.src = `/api/v2/page/music/${musicId}`
      // item.value = `/api/v2/page/music/${musicId}`
      item.src = url
      item.value = url
      item.musicName = musicName
      this.$set(container.items, itemIdx, item)
    },
    /** 删除音乐 */
    async handleFormMusicDelete(pageId, containerIdx, itemIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const rowId = -1
      const item = container.items[itemIdx]
      const colId = item.id

      const musicSrc = item.src
      const array = _.split(musicSrc, '/')
      const musicId = array[array.length - 1]

      await PageModel.deleteMusic({
        pageId,
        containerId,
        rowId,
        colId,
        musicId,
      })

      item.src = ''
      item.value = ''
      item.musicName = ''
      this.$set(container.items, itemIdx, item)
    },
    /** 上传视频成功的回调函数 */
    handleFormVideoUploadSuccess(pageId, containerIdx, itemIdx, response) {
      const container = this.pageInfo.containers[containerIdx]
      const item = container.items[itemIdx]
      const videoId = response.musicId
      const url = response.url
      // item.src = `/api/v2/page/music/${videoId}`
      // item.value = `/api/v2/page/music/${videoId}`
      item.src = url
      item.value = url
      this.$set(container.items, itemIdx, item)
    },
    /** 删除视频 */
    async handleFormVideoDelete(pageId, containerIdx, itemIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const rowId = -1
      const item = container.items[itemIdx]
      const colId = item.id

      const videoSrc = item.src
      const array = _.split(videoSrc, '/')
      const videoId = array[array.length - 1]
      await PageModel.deleteVideo({
        pageId,
        containerId,
        rowId,
        colId,
        videoId,
      })

      item.src = ''
      item.value = ''
      item.videoName = ''
      this.$set(container.items, itemIdx, item)
    },
    /** 上传文件成功的回调函数 */
    handleFormFileUploadSuccess(pageId, containerIdx, itemIdx, response) {
      const container = this.pageInfo.containers[containerIdx]
      const item = container.items[itemIdx]
      const fileId = response.fileId
      const url = response.url
      const fileName = response.fileName
      // item.src = `/api/v2/page/file/${fileId}`
      // item.value = `/api/v2/page/file/${fileId}`
      item.src = url
      item.value = url
      item.fileName = fileName
      this.$set(container.items, itemIdx, item)
    },
    /** 删除文件 */
    async handleFormFileDelete(pageId, containerIdx, itemIdx) {
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const rowId = -1
      const item = container.items[itemIdx]
      const colId = item.id

      const fileSrc = item.src
      const array = _.split(fileSrc, '/')
      const fileId = array[array.length - 1]

      await PageModel.deleteFile({
        pageId,
        containerId,
        rowId,
        colId,
        fileId,
      })

      item.src = ''
      item.value = ''
      item.fileName = ''
      this.$set(container.items, itemIdx, item)
    },
    /** 为表格增加一行 */
    async handleCreateALine(pageId, containerId) {
      let row = await PageModel.createALine({ pageId, containerId })
      const containerIdx = _.findIndex(
        this.pageInfo.containers,
        (container) => container.containerId === containerId
      )
      const container = this.pageInfo.containers[containerIdx]
      row = Formatter.formatTableRow(
        row,
        _.map(container.cols, (col) => col.colId)
      )
      container.rows.push(row)
    },
    /** 拷贝行 */
    async handleCopyALine(pageId, containerId, sourceRow) {
      const sourceRowId = sourceRow.rowId
      let rows = await PageModel.copyALine({ pageId, containerId, sourceRowId })

      const containerIdx = _.findIndex(
        this.pageInfo.containers,
        (container) => container.containerId === containerId
      )
      const container = this.pageInfo.containers[containerIdx]
      const sourceRowIdx = _.findIndex(
        container.rows,
        (row) => row.rowId === sourceRowId
      )

      container.rows = _.filter(
        container.rows,
        (item, index) => index <= sourceRowIdx
      )

      _.forEach(rows, (row) => {
        row = Formatter.formatTableRow(
          row,
          _.map(container.cols, (col) => col.colId)
        )
        container.rows.push(row)
      })

      // const length = container.rows.length
      // for (let i = sourceRowIdx + 1; i < length; i++) {
      //   const targetRowId = container.rows[i].rowId
      //   const newRow = _.cloneDeep(sourceRow)
      //   newRow.rowId = targetRowId
      //   this.$set(container.rows, i, newRow)
      // }
    },
    /** 删除表格指定行 */
    async handleDeleteLines(pageId, containerId, rows) {
      const rowIds = _.join(_.map(rows, (row) => row.rowId))
      await PageModel.deleteLines({ pageId, containerId, rowIds })

      const containerIdx = _.findIndex(
        this.pageInfo.containers,
        (container) => container.containerId === containerId
      )
      const container = this.pageInfo.containers[containerIdx]
      container.rows = _.filter(
        container.rows,
        (row) => !_.includes(_.split(rowIds, ','), row.rowId)
      )
    },

    /** 状态按钮提交数据 */
    handelButtonSubmit(rowId, tips, rows, cols) {
      let arr = []
      _.forEach(cols, (item) => {
        if (item.required && rows[0][item.colId].value === '') {
          arr.push(item.label)
        }
      })
      if (arr.length > 0) {
        let str = arr.join(',')
        let msg = this.$t('page.TIPS_FOR_BUTTON_SUBMIT', { requireText: str })
        this.$message({
          showClose: true,
          message: msg,
          type: 'error',
        })
      } else {
        const title = this.$t('global.TIPS')
        this.$confirm(tips, title, {
          confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
          cancelButtonText: this.$t('page.SUBMIT_CONFIRM_CANCEL'),
        })
          .then(async () => {
            const { gameId, teamId } = storage.getItem(constants.GLOBAL_CONFIG)
            const { pId } = this.pageInfo
            let data = await PageModel.buttonSubmit(gameId, teamId, pId, rowId)
            if (data.errNo === 0) {
              Notification.success({
                title: '成功',
                message: '提交成功',
                showClose: true,
              })
            } else if (data.errNo === 2) {
              Notification.error({
                title: '失败',
                message: data.errMsg,
                showClose: true,
              })
            }
          })
          .catch(() => {})
      }
    },

    /** html编辑 */
    handelHtmlShow(defauleValue, value, pageId, containerIdx, rowIdx, colIdx) {
      this.htmlEditShow = true
      this.htmlEditContent = defauleValue
      this.htmlSaveInfo = { pageId, containerIdx, rowIdx, colIdx }
      if (this.isJSON(value)) {
        let obj = JSON.parse(value)
        setTimeout(() => {
          for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
              const element = obj[key]
              let eleArr = $('#form :input[name="' + key + '"]')[0]
              if (eleArr.tagName == 'INPUT' || eleArr.tagName == 'TEXTAREA') {
                eleArr.setAttribute('value', element)
              }
              if (eleArr.tagName == 'TEXTAREA') {
                eleArr.innerHTML = element
              }
              if (eleArr.tagName == 'SELECT') {
                let optionObj = _.find(
                  eleArr.options,
                  (item) => item.value == element
                )
                optionObj.setAttribute('selected', 'selected')
              }
            }
          }
        }, 500)
      }
    },

    openActions(token) {
      this.token = 'http://actions.justtool.com/#/2/' + token
      setTimeout(() => {
        this.actionsShow = true
      }, 500)
    },

    htmlCancel() {
      this.htmlEditShow = false
      this.htmlEditContent = ''
    },

    async htmlSave() {
      let arrayTmp = $('#form').serializeArray()
      let obj = {}
      $.each(arrayTmp, function () {
        let str1 = this.value.replace(/[\f\r\n\t]/g, '')
        obj[this.name] = str1 || ''
      })

      const data = JSON.stringify(obj)
      let { pageId, containerIdx, rowIdx, colIdx } = this.htmlSaveInfo
      const container = this.pageInfo.containers[containerIdx]
      const containerId = container.containerId
      const row = container.rows[rowIdx]
      const rowId = row.rowId
      const col = container.cols[colIdx]
      const colId = col.colId

      try {
        await PageModel.saveData({
          pageId,
          containerId,
          rowId,
          colId,
          data,
        })
      } catch (error) {
        throw error
      }
      this.$message.success(this.$t('page.HTML_SAVE_SUCCESS'))
      row[colId].value = data
      this.$set(container.rows, rowIdx, row)
    },

    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj == 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      }
    },

    /** 关闭难度窗 */
    handleClose() {
      this.$confirm(this.$t('page.DIFFICULTY_CLOSE_TIPS')).then(async () => {
        this.actionsShow = false
        this.token = ''
        await this._initPage()
      })
    },

    /** 初始化页面数据 */
    async _initPage() {
      let tradeNo = localStorage.getItem('tradeNo')

      if (tradeNo) {
        try {
          await PageModel.cancelpay(tradeNo)
        } catch (error) {
        } finally {
          localStorage.removeItem('tradeNo')
          window.history.go(0)
        }
      } else {
        this.loading = true
        const router = this.$router
        const pageId = router.history.current.params.pageId
        this.pageInfo = {}
        let { pageInfo, pageProperty } = await PageModel.getPageInfo(pageId)
        if (window.innerWidth < 768) {
          pageInfo.buttons = pageInfo.buttons.filter((item) => item.type !== 4)
        }
        this.loading = !pageInfo
        let obj = Formatter.formatPageInfo(pageInfo)

        this.pageInfo = obj
        this.paystatus = 1
        this.pageProperty = pageProperty || {}
        if (this.timers) {
          clearInterval(this.timers)
        }
        this.payshow = false
      }
    },
  },

  async created() {
    await this._initPage()
  },

  watch: {
    async $route(to, from) {
      await this._initPage()
    },
  },
}
</script>

<style lang="stylus">
.main-container {
  .center-container {
    height: calc(100vh - 193px);
    padding: 0 8px;
    overflow: auto;
  }

  .btn-container {
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .btn {
      width: 200px;
      margin: 0 2%;
    }
  }

  .el-dialog {
    width: 95%;
    min-width: 320px;
    max-width: 420px;
    margin: 0 auto;

    .el-dialog__body {
      padding: 10px;
    }

    .el-dialog__header {
      padding: 10px 10px 0px;
    }
  }

  .actionsModal {
    width: 95%;
    max-width: 1200px;
  }

  .htmldialog {
    max-width: 800px;

    .htmlEditButton {
      margin-top: 20px;
    }
  }

  .createteam {
    .tips {
      padding: 5px;
      background-color: #ffc967;
      line-height: 22px;
      margin-bottom: 10px;
    }

    label {
      font-size: 16px;
    }

    p {
      margin: 10px 0;

      button {
        width: 90px;
      }
    }
  }
}

.successmsg {
  i {
    margin-right: 10px;
  }

  font-size: 16px;
  margin-bottom: 20px;
  line-height: 24px;
}

.copybut {
  text-align: center;

  button {
    width: 100px;
  }
}

.el-message-box__wrapper {
  .el-message-box {
    max-width: 420px;
    min-width: 250px;
    width: auto;
  }
}

.sub-container {
  padding: 10px;
}

.cropper {
  width: 100%;
  height: 400px;
}

.paysuccessdialog {
  min-height: 150px;

  // display: flex;
  // justify-content: center;
  // align-items: center;
  .successicon {
    text-align: center;

    i {
      font-size: 50px;
      color: #67c23a;
    }

    .successcontent {
      font-size: 18px;
      margin: 15px 0;
    }
  }
}

.paydialog {
  text-align: center;

  .title {
    text-align: left;
    font-size: 18px;
    line-height: 22px;
  }

  img {
    width: 100%;
  }
}

.suctitle {
  color: green;
  font-size: 16px;
  padding-bottom: 5px;
  line-height: 22px;
  margin-bottom: 5px;
}

.codetab {
  border-top: 1px solid #dadada;

  p {
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 22px;
  }
}

.pdf {
  padding: 10px 0;
}

.successbut {
  text-align: center;
  margin-top: 10px;

  button {
    width: 120px;
  }
}

.headertips {
  padding: 5px;
  border: 1px solid #dadada;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin-bottom: 10px;
}

.difficulty-title {
  p {
    font-size: 16px;
    width: 100%;
    margin-bottom: 10px;

    span {
      display: inline-block;
      width: 50%;
      color: #333;

      label {
        font-weight: bold;
      }
    }
  }
}

.difficulty-score {
  font-size: 16px;
  width: 100%;
  margin: 15px 0;

  span {
    display: inline-block;
    width: 33.3%;
    color: #f00;
    font-weight: bold;

    label {
      color: #333;
    }
  }
}

.required-input {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  p {
    display: flex;
    width: 24%;
    margin-right: 1%;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    align-items: center;

    label {
      display: inline-block;
      min-width: 40px;
      text-align: center;
    }

    b {
      width: 100%;
      height: 40px;
      display: inline-block;
      border: 1px solid #ccc;
      overflow: hidden;
      line-height: 40px;
      padding: 0 5px;
      color: #333;
    }
  }
}
</style>
